module.exports = __webpack_public_path__ + "static/media/ic-archive-box-v2.138ceecd.svg";